<mat-card>
  <mat-card-header>
    <mat-card-title>CenturyLink Fiber</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    @if (circuit.loss == 0) {
      <span id="network-health-badge-green">
        <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (circuit.loss != 0) {
      <span id="network-health-badge-red">
        <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    <p><b>IP:</b> {{circuit.serverIp}}</p>
    <p><b>Jitter:</b> {{circuit.jitter}}</p>
    <p><b>Packet Loss:</b> {{circuit.loss}}</p>
    <p><b>Max Latency:</b> {{circuit.maxLatency}}</p>
    <p><b>Min Latency:</b> {{circuit.minLatency}}</p>
    <p><b>Average Latency:</b> {{circuit.avgLatency}}</p>
  </mat-card-content>
</mat-card>